export default __webpack_public_path__ + "7663d39c89191ce3c216365ffe43b9a9.svg";